import api from './api';

export const getActivities = (page, params) => {
  return api.get('admin/Activities', { params: { page: page, limit: 5, order: 'createdAt', direction: 'DESC', ...params } });
};